import { useState } from "react";

// Sezioni contraibili della Home: lo stato aperto/chiuso resta salvato per ogni riquadro.
export function usePersistedBool(key, def = true) {
  const [v, setV] = useState(() => {
    const s = localStorage.getItem(key);
    return s === null ? def : s === "1";
  });
  return [v, (nv) => { localStorage.setItem(key, nv ? "1" : "0"); setV(nv); }];
}
